import { EMPRESAS_PAGE_SIZE } from '@/pages/empresasPageConstants'

export type EmpresasListParamsInput = {
  page: number
  limit?: number
  search?: string
  status?: string
}

/** Query params for GET /empresas — search/status/page no servidor. */
export function buildEmpresasListParams(input: EmpresasListParamsInput): Record<string, string | number> {
  const params: Record<string, string | number> = {
    page: Math.max(1, input.page || 1),
    limit: input.limit ?? EMPRESAS_PAGE_SIZE,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  }
  const q = input.search?.trim()
  if (q) params.search = q
  if (input.status?.trim()) params.status = input.status.trim()
  return params
}
